/**
 * External Dependencies
 */
import { IconFlagOff } from '@tabler/icons';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';

const flagAssets = require.context(
  '../../../assets/images/country_flags',
  false,
  /\.svg$/
);

const specialFlags = {
  en: 'gb',
  ce: 'cefta',
};

const loadFlag = countryCode => {
  const flagName = specialFlags[countryCode] || countryCode;

  try {
    return flagAssets(`./${flagName}.svg`);
  } catch (error) {
    return null;
  }
};

/**
 * Component
 *
 * @param {Object} props component props.
 * @return {Object} component.
 */
const Bandiera = props => {
  const { country, size } = props;
  const flagSrc = useMemo(() => country && loadFlag(country), [country]);

  if (!flagSrc) {
    return <IconFlagOff size={size ? size : '15'} />;
  }

  return (
    <img
      style={{
        width: size ? size : '15px',
        border: '1px solid',
        borderRadius: '3px',
      }}
      {...props}
      src={flagSrc}
      loading="lazy"
      alt={country}
    />
  );
};

export default connect(({ settings }) => ({
  settings,
}))(Bandiera);
